import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./index.scss";
import useInfoContext from "hooks/useInfoContext";
import GalleryImg from "assets/images/galleryImg.png";
import CameraImg from "assets/images/cameraImg.png";
import CustomModalCropProfile from "./customModalCrop";
import OnAcademyLogoProfile from "assets/images/onAcademyLogoProfile.png";
import { useNavigate } from "react-router-dom";
import { useGetMyProfile, useUpdateProfile } from "hooks/user";
import CustomModalSuccess from "components/modalSuccses";

const MyProfile = () => {
  const { userInfo, setUserInfo } = useInfoContext();
  const navigate = useNavigate();
  const [openPictureCrop, setOpenPictureCrop] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [profileStatus, setProfileStatus] = useState("selectImg");
  const [direction, setDirection] = useState("rtl");
  const [description, setDescription] = useState();
  const { mutate: updateProfileRequest } = useUpdateProfile();
  const { mutate: getMyProfile } = useGetMyProfile();

  const handleCloseModalOpenCrop = () => {
    setOpenPictureCrop(false);
  };

  const handleOpenGallery = () => {
    document.getElementById("upload-photo").click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImagePreview(URL.createObjectURL(file));
    setOpenPictureCrop(true);
  };

  const handleOpenCamera = () => {
 // open camera
 console.log("open camera");
  };

  const handleDirectionChange = (event) => {
    const value = event.target.value;
    const isRTL = /[\u0600-\u06FF]/.test(value);
    setDirection(isRTL ? "rtl" : "ltr");
    setDescription(value);
    if (!value) {
      setDirection("rtl");
    }
  };

  const submitInfoabout = () => {
    updateProfileRequest(
      {
        about: description,
      },
      {
        onSuccess: (response) => {
          if (response.status === "OK") {
            setProfileStatus("createdProfile");
          }
        },
      }
    );
  };

  const handleCloseAlert = () => {
    setModalAlert(false);
  };

  useEffect(() => {
    if (profileStatus === "createdProfile") {
      getMyProfile(
        {},
        {
          onSuccess: ({ status, user }) => {
            if (status === "OK" && user) {
              setUserInfo(user);
            }
          },
          onError: (e) => {
            console.error(e);
          },
        }
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileStatus]);

  return (
    <Box className="container-box-profile">
      <CustomModalCropProfile
        open={openPictureCrop}
        close={handleCloseModalOpenCrop}
        imagePreview={imagePreview}
        setOpenPictureCrop={setOpenPictureCrop}
        setProfileStatus={setProfileStatus}
      />
      <CustomModalSuccess
        open={modalAlert}
        close={handleCloseAlert}
        title="فایل شما بزرگ تر از ۲ مگابایت است"
        detail="لطفا از فایل های کوچک تر از ۲ مگابایت استفاده کنید"
        resultStatus={false}
      />
      <Grid2 container className="container-profile" columns={12}>
        <Grid2 item className="top-box-img">
          <img
            src={`https://fs.zharfabeen.com/onacademyp/${
              userInfo?.username
            }_profile?${new Date().getTime()}`}
            alt="profile"
            style={{ width: "100%", Height: "100%", borderRadius: "10px" }}
          />
          {profileStatus !== "selectImg" && (
            <Box className="onacademy-logo">
              <img src={OnAcademyLogoProfile} alt="Logo" />
            </Box>
          )}
          <Box className="name-text">{userInfo?.cardName}</Box>
          {profileStatus !== "selectImg" && (
            <Box className="frequency">{userInfo?.frequency}</Box>
          )}
          {profileStatus === "createdProfile" && (
            <Box className="description-profile">{userInfo?.about}</Box>
          )}
        </Grid2>
        {profileStatus === "selectImg" ? (
          <Grid2 item size={{ xs: 12 }} className="bottom-box-select">
            <Grid2 item size={{ xs: 12 }} className="title-select">
              <Typography variant="h5">پوستر خود را انتخاب کنید</Typography>
            </Grid2>
            <Grid2 container size={{ xs: 12 }} className="select-img-container">
              <Grid2
                item
                size={{ xs: 5 }}
                className="box-select-img"
                onClick={handleOpenCamera}
              >
                <Box className="camera-image">
                  <img src={CameraImg} alt="Camera" />
                </Box>
                <Box className="bottom-text">
                  <Typography variant="h6">دوربین</Typography>
                </Box>
              </Grid2>
              <Grid2
                item
                size={{ xs: 5 }}
                className="box-select-img"
                onClick={handleOpenGallery}
              >
                <input
                  type="file"
                  accept="image/*"
                  id="upload-photo"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <Box className="gallery-image">
                  <img src={GalleryImg} alt="Gallery" />
                </Box>
                <Box className="bottom-text">
                  <Typography variant="h6">گالری</Typography>
                </Box>
              </Grid2>
            </Grid2>
          </Grid2>
        ) : profileStatus === "bio" ? (
          <Grid2 item size={{ xs: 12 }} className="bottom-box-select">
            <Grid2 item size={{ xs: 12 }} className="box-textarea">
              <textarea
                name="bio"
                className="textarea-bio"
                style={{ direction }}
                placeholder="چند جمله درباره خودتان بنویسید(اختیاری)"
                onChange={handleDirectionChange}
                maxLength={75}
                defaultValue={userInfo?.about}
              />
              <Button
                variant="contained"
                className="continue-bio"
                onClick={submitInfoabout}
              >
                بعدی
              </Button>
            </Grid2>
          </Grid2>
        ) : profileStatus === "createdProfile" ? (
          <Grid2 item size={{ xs: 12 }} className="bottom-box-select">
            <Grid2 item size={{ xs: 12 }} className="parent-box-succses">
              <Box className="box-succses">
                <Box className="text-create-profile">
                  پروفایل شما با موفقیت ساخته شد
                </Box>
                <Button
                  variant="contained"
                  className="continue-bio"
                  onClick={() => {
                    navigate("/on-card");
                  }}
                >
                  بازگشت
                </Button>
              </Box>
            </Grid2>
          </Grid2>
        ) : null}
      </Grid2>
    </Box>
  );
};

export default MyProfile;
